<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <topnav></topnav>
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <sidebar></sidebar>
      <router-view></router-view>
    </div>
    <footer-bar></footer-bar>
  </div>
</template>
<script>
import TopNav from "../navigation/TopNav";
import SideBar from "../navigation/SideBar";
import Footer from "../partials/Footer";

export default {
  components: {
    topnav: TopNav,
    sidebar: SideBar,
    footerBar: Footer
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Dashboard.vue